export default __webpack_public_path__ + "images/journal-60.svg";